<dx-popup
    [width]="760"
    [height]="560"
    [title]="this.chartTitle"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [shading]="false"
    (onHidden)="this.onHidden()">

    <div *dxTemplate="let data of 'content'" class="hs-chart">

        <div class="hs-chart-controls">
            <!-- div, NOT <label>: a label re-dispatches clicks to its inner input, so clicking a
                 DX editor's drop-down BUTTON toggles the dropdown twice (open → instantly closed). -->
            <div class="win">
                <span class="cap">Start</span>
                <dx-select-box
                    [items]="this.startOptions"
                    [(value)]="this.startExpiration"
                    displayExpr="label" valueExpr="value"
                    [width]="170"
                    (onValueChanged)="this.onStartChanged($event)">
                </dx-select-box>
            </div>
            <div class="win">
                <span class="cap">End</span>
                <dx-select-box
                    [items]="this.endOptions"
                    [(value)]="this.endExpiration"
                    displayExpr="label" valueExpr="value"
                    [width]="170"
                    (onValueChanged)="this.onEndChanged()">
                </dx-select-box>
            </div>

            <dx-button-group
                class="basis-toggle"
                [items]="this.basisButtons"
                keyExpr="id"
                selectionMode="single"
                stylingMode="contained"
                [selectedItemKeys]="[this.basis]"
                (onItemClick)="this.onBasisToggle($event)">
            </dx-button-group>

            <dx-button class="plot-btn" icon="refresh" text="Plot" (onClick)="this.onPlot()"></dx-button>

            <span class="spacer"></span>

            <dx-button text="Reset Zoom" (onClick)="this.resetZoom()"></dx-button>
        </div>

        <div #plotHost class="hs-chart-plot">

            <dx-chart *ngIf="this.hasCurve" [dataSource]="this.chartData" class="hs-dxchart">
                <dxi-series argumentField="expLabel" valueField="ivPct" type="line" color="#4488ff">
                    <dxo-point [visible]="true" [size]="7"></dxo-point>
                </dxi-series>

                <dxo-argument-axis argumentType="string">
                    <dxo-title text="Expiration"></dxo-title>
                    <dxo-label overlappingBehavior="rotate" [rotationAngle]="-45"></dxo-label>
                </dxo-argument-axis>

                <dxi-value-axis>
                    <dxo-title text="ATM IV"></dxo-title>
                    <dxo-label [customizeText]="this.pctLabel"></dxo-label>
                </dxi-value-axis>

                <dxo-zoom-and-pan
                    argumentAxis="both" valueAxis="both"
                    [allowMouseWheel]="true" [allowTouchGestures]="true" [dragToZoom]="true">
                </dxo-zoom-and-pan>

                <dxo-crosshair [enabled]="true">
                    <dxo-label [visible]="true"></dxo-label>
                </dxo-crosshair>

                <dxo-tooltip [enabled]="true" [customizeTooltip]="this.tooltipFn"></dxo-tooltip>
                <dxo-legend [visible]="false"></dxo-legend>
            </dx-chart>

            <div *ngIf="!this.hasCurve && !this.isLoading" class="hs-chart-empty">
                {{ this.emptyMessage || 'No data.' }}
            </div>

            <dx-load-panel
                [position]="{ my: 'center', at: 'center', of: plotHost }"
                [visible]="this.isLoading"
                [showPane]="true">
            </dx-load-panel>
        </div>

        <div class="hs-chart-legend">
            <span class="dot"></span>
            <span class="txt">{{ this.legendText }}</span>
            <span class="hint">Scroll to zoom · drag to pan · use Reset zoom to restore</span>
        </div>

    </div>
</dx-popup>
